// Utility function to convert image URLs to production domain
export const getImageUrl = (url) => {
  if (!url) return '';
  
  // Always use production domain
  const baseUrl = 'https://fciveria.ge';
  
  // If it's already a full URL with the production domain, return as is
  if (url.includes('https://fciveria.ge')) {
    return url;
  }
  
  // If it's a localhost URL, convert it to production domain
  if (url.includes('localhost:5000')) {
    return url.replace('http://localhost:5000', baseUrl);
  }
  
  // If it's a relative URL, prepend the production domain
  if (url.startsWith('/')) {
    return `${baseUrl}${url}`;
  }
  
  // If it's already a full URL, return as is
  return url;
};

// Always use production domain for images - no environment detection
export const getImageUrlWithEnv = (url) => {
  if (!url) return '';
  
  // ALWAYS use production domain for images
  const baseUrl = 'https://fciveria.ge';
  
  // If it's already a full URL with the production domain, return as is
  if (url.includes('https://fciveria.ge')) {
    return url;
  }
  
  // If it's a localhost URL, convert it to production domain
  if (url.includes('localhost:5000')) {
    console.log('Converting localhost image URL to production:', url);
    return url.replace('http://localhost:5000', baseUrl);
  }
  
  // If it's a relative URL, prepend the production domain
  if (url.startsWith('/')) {
    console.log('Converting relative image URL to production:', url);
    return `${baseUrl}${url}`;
  }
  
  // If it's already a full URL, return as is
  return url;
};





